export default "__VITE_ASSET__DgE2bgtb__"